import { SvgMatType } from "../constants/icons";

export class NavgiationLink {
    label: string;
    link: string;
    svg?: SvgMatType;
    menuLinks?: MenuLink[];
    isIconOnly?: boolean;

    constructor() {
        this.label = null;
        this.link = null;
        this.svg = null;
        this.menuLinks = Array<MenuLink>();
        this.isIconOnly = false;
    }
}

export class MenuLink {
    label: string;
    link: string;
    svg?: SvgMatType;

    constructor() {
        this.label = null;
        this.link = null;
        this.svg = null;
    }
}

export class NavgiationTimeLine extends NavgiationLink {
    label: string;
    link: string;
    isActive: boolean;
    isCompleted: boolean;

    constructor() {
        super();
        this.label = null;
        this.link = null;
        this.isActive = false;
        this.isCompleted = false
    }
}

export class NavigationTopNav {
    links: NavgiationLink[];

    constructor() {
        this.links = Array<NavgiationLink>();
    }
}

export class NavigationSubNav {
    isTimeLine: boolean;
    links: NavgiationLink[];
    timeLine: NavgiationTimeLine[];

    constructor() {
        this.isTimeLine = false;
        this.links = Array<NavgiationLink>();
        this.timeLine = Array<NavgiationTimeLine>();
    }
}